import { ReactNode } from "react";

export interface ModalConfig {
  title: string;
  body?: ReactNode;
  danger?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  onConfirm?: () => void;
}

export function Modal({
  config,
  onClose,
}: {
  config: ModalConfig | null;
  onClose: () => void;
}) {
  if (!config) return null;
  return (
    <div className="lpc-modal" role="dialog" aria-modal="true">
      <div className="lpc-modal__box">
        <div className="lpc-modal__title">{config.title}</div>
        {config.body ? <div className="lpc-modal__body">{config.body}</div> : null}
        {config.danger ? <div className="lpc-modal__danger">{config.danger}</div> : null}
        <button
          className="btn btn--primary"
          data-testid="modal-confirm"
          onClick={() => {
            onClose();
            config.onConfirm?.();
          }}
        >
          {config.confirmLabel ?? "Confirmar"}
        </button>
        <button className="btn btn--ghost" data-testid="modal-cancel" onClick={onClose}>
          {config.cancelLabel ?? "Voltar"}
        </button>
      </div>
    </div>
  );
}
